'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaPlane = function FaPlane(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.7 3.6q1 1.1 0.3 3.3t-2.4 3.8l-3.6 3.6 3.5 15.5q0.2 0.5-0.2 0.8l-2.9 2.1q-0.1 0.2-0.4 0.2-0.1 0-0.2-0.1-0.3 0-0.4-0.3l-6.3-11.4-5.7 5.8 1.1 4.4q0.2 0.3-0.1 0.6l-2.2 2.2q-0.2 0.2-0.5 0.2h0q-0.4-0.1-0.6-0.3l-4.2-5.6-5.6-4.2q-0.3-0.2-0.3-0.6 0-0.2 0.2-0.5l2.1-2.2q0.2-0.2 0.6-0.2 0.1 0 0.1 0l4.4 1.2 5.7-5.8-11.3-6.2q-0.3-0.2-0.4-0.5 0-0.4 0.2-0.6l2.9-2.9q0.3-0.3 0.7-0.2l14.8 3.6 3.6-3.6q1.7-1.7 3.8-2.4t3.3 0.3z' })
        )
    );
};

exports.default = FaPlane;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-icons/lib/fa/plane.js
 ** module id = 1778
 ** module chunks = 0
 **/